<template>
    <div>
        <!-- <select-shop @getData="handleShopObjectIdChange" :loadingButton="!loadingButton"></select-shop> -->
           <CCard class="shadow-sm">
        <CCardBody>
          <CRow>
            <CCol class="d-flex col-12 col-md-12 col-sm-12">
              <img src="/img/icon/store.png" style="width: 32px; height:32px; margin-right: 8px;"/>
                <select
                  class="custom-select"
                  v-model="shopObjectId"
                  disabled
                >
                  <option selected>{{ $t('selectshop') }}</option>
                  <option
                    v-for="shop in shops"
                    :key="shop.objectId"
                    :value="shop.objectId"
                  >
                    {{ shop.shopName }} - {{ shop.branchName }}
                  </option>
                </select>
            </CCol>
            <!-- <CCol sm="3" md="2" col="3" >
              <router-link :to="`/report/daily`">
                <CButton block color="light"  class="align-items-center">
                  <span><i class="fi fi-rr-arrow-left mr-2" style="position: relative; top: 2px;"></i></span>{{ $t('back') }}
                </CButton>
              </router-link>
            </CCol> -->
          </CRow>
        </CCardBody>
      </CCard>
        
        <div v-if="isPermission">
            <div v-show="!loading">
                <CCard class="shadow-sm">
                    <CCardBody class="p-4">
                        <div class=" row">
                            <div class="col-12 d-flex justify-content-between">
                                <CButton color="light" @click="$router.push('/promotion')"
                                    class="align-items-center pr-4 pl-4">
                                    <span><i class="fi fi-rr-arrow-left mr-2"
                                            style="position: relative; top: 2px;"></i></span>{{ $t('exitPage') }}
                                </CButton>
                                <img @click="deleteModal = true" src="/img/trash.png"
                                    style="width: 24px; height: 24px; cursor: pointer;" />
                            </div>
                            <div class="col-12 text-center mt-4">
                                <h3>{{ $t('promotionDetailHeader') }}</h3>
                                <span>{{
                                    $t('promotionDetailHeaderDesp')
                                    }}</span>
                            </div>
                        </div>
                        <div v-if="!isGrabPromotion()" class="promotion-form d-flex justify-content-between mt-5">
                            <div>
                                <h5 class="d-flex align-items-center" @click="toggleActivationModal()">
                                    <CSwitch class="mr-3" color="success" :checked.sync="promotion.isActive" />
                                    <template v-if="promotion.isActive"> {{ $t('promotionActive') }}</template>
                                    <template v-else> {{ $t('promotionNotActive') }}</template>
                                </h5>
                            </div>
                            <CButton color="primary" @click="toggleCloneModal()">
                                {{ $t('clonePromotionTitle') }}
                            </CButton>

                        </div>
                        <div class="mt-4" v-if="disabledForm()">
                            <CAlert class="text-center" color="warning">
                                {{ $t('onGoingPromotionDesp') }}
                                <span @click="toggleGrabInfoModal()" class="ml-1"
                                    style="text-decoration: underline;cursor: pointer;">
                                    {{ $t('moreInfo') }}
                                </span>
                            </CAlert>
                        </div>
                        <div class="pl-2 pr-2">
                            <div class="promotion-form mt-5">
                                <div>
                                    <AppPromotionResultForm :key="'AppPromotionResultForm'" ref="resultsComponent"
                                        class="mt-5" :promotionType="promotion.type" :resultsDisplay="promotion.results"
                                        :isReadonly="true" :isGrabTemplate="isGrabPromotion()" :conditionType="promotion.condition.type">
                                    </AppPromotionResultForm>
                                </div>
                            </div>
                            <div v-show="!noConditionRequired.includes(promotion.condition.type)"
                                class="promotion-form mt-5">
                                <div>
                                    <AppPromotionConditionForm :key="'AppPromotionConditionDisplay'"
                                        ref="conditionComponent" class="mt-5" :conditionType="promotion.condition.type"
                                        :isReadonly="true" :conditionDisplay="promotion.condition">
                                    </AppPromotionConditionForm>
                                </div>
                            </div>

                        </div>
                        <div>
                            <AppPromotionDetailsForm v-if="!loading" ref="detailsComponent" :promotion="promotion"
                                :isGrabPromotionAllow="isGrabPromotion()" :isEmptyForm="false" />
                        </div>
                    </CCardBody>
                </CCard>
                <div v-if="!disabledForm()" class=" row justify-content-end mb-4 mt-2">
                    <div class="col-6 col-md-2 pt-1">
                        <CButton @click="$router.push('/promotion')" block color="light"
                            style="background-color: white;">{{
                                $t('cancel') }}</CButton>
                    </div>
                    <div class="col-6 col-md-2 pt-1">
                        <CButton @click="toggleSaveModal()" block color="success">{{ $t('save') }}</CButton>
                    </div>
                </div>
                <CModal :show.sync="alertModal" centered :title="$t('saveFailedHeader')" color="danger" header="false">
                    <div class="text-center p-3">

                        <h5 style="line-height: 180%;" v-html="getErrorMessage()" />
                        <span v-if="errorMessage !== 'validateInfomation'" style="color: gray">({{ errorMessage
                            }})</span>
                    </div>
                    <template #footer>
                        <div class="w-100 d-flex justify-content-center">
                            <CButton style="width: 100%;margin-left: 1cap;" @click="alertModal = false" color="light">
                                <CSpinner v-if="loading" color="white" size="sm" />
                                <b>{{ $t("agreed") }}</b>
                            </CButton>
                        </div>
                    </template>
                </CModal>
                <CModal :show.sync="saveModal" centered :title="$t('saveMember')" color="success" header="false">
                    <div class="text-center pt-4 pb-4">
                        <!-- <div class="json-display text-left">
                            <pre>{{ prettyJson(promotion) }}</pre>
                        </div> -->
                        <h4>
                            {{ $t('confirmEditPromotion') }}
                        </h4>
                    </div>
                    <template #footer>
                        <div class="row w-100">
                            <div class="col-6">
                                <CButton @click="saveModal = false" block color="light">{{ $t('cancel') }}
                                </CButton>
                            </div>
                            <div class="col-6">
                                <CSpinner v-if="loading" color="white" size="sm" />
                                <CButton :disabled="loading" @click="saveData()" block color="success">{{ $t('submit')
                                    }}</CButton>
                            </div>
                        </div>
                    </template>
                </CModal>
                <CModal :show.sync="activationModal" centered :title="$t('confirmEditPromotion')" color="success"
                    header="false">
                    <div class="p-3 text-center">
                        <h4>{{ $t('confirmEditPromotion') }}</h4>
                        <div class="text-center" style="color: gray;">
                            <div v-if="promotion.isActive" v-html="$t('confirmActivePromotion')">
                            </div>
                            <div v-html="$t('confirmDeActivePromotion')" v-else></div>
                        </div>
                    </div>
                    <template #footer>
                        <div class="row w-100">
                            <div class="col-6">
                                <CButton @click="activationModal = false" block color="light">{{ $t('cancel') }}
                                </CButton>
                            </div>
                            <div class="col-6">
                                <CButton @click="saveData()" block color="success">{{ $t('submit') }}</CButton>
                            </div>
                        </div>
                    </template>
                </CModal>
                <CModal :show.sync="deleteModal" centered :title="$t('confirmEditPromotion')" color="danger"
                    header="false">
                    <div class="text-center p-3">
                        <h4>{{ $t('confirmDeletePromotion') }}</h4>
                        <span style="color: gray" v-html="$t('confirmDeletePromotionDesp')" />
                        <!-- <div class="json-display">
                        <pre>{{ prettyJson(promotionData) }}</pre>
                    </div> -->
                    </div>
                    <template #footer>
                        <div class="row w-100">
                            <div class="col-6">
                                <CButton :disabled="loading" @click="deleteModal = false" block color="light">{{
                                    $t('cancel') }}
                                </CButton>
                            </div>
                            <div class="col-6">
                                <CButton :disabled="loading" @click="deletePromotion()" block color="danger">{{
                                    $t('submit') }}</CButton>
                            </div>
                        </div>
                    </template>
                </CModal>
            </div>
            <div v-show="loading">
                <CCard class="shadow-sm">
                    <CCardBody>
                        <div style="width: 100%; min-height: 50vh; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 20px;">
                            <div style="position: relative; width: 56px; height: 56px;">
                                <div style="width: 56px; height: 56px; border: 4px solid #f0f0f0; border-top: 4px solid #2eb85c; border-radius: 50%; animation: promotionSpin 0.8s linear infinite;"></div>
                                <i class="fi fi-rr-ticket" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 1.2rem; color: #2eb85c;"></i>
                            </div>
                            <div class="text-center">
                                <div style="color: #333; font-weight: 500; font-size: 0.95rem;">{{ $t('loadingPromotion') }}</div>
                                <div style="color: #aaa; font-size: 0.82rem; margin-top: 4px;">{{ $t('loadingPleaseWait') }}</div>
                            </div>
                        </div>
                    </CCardBody>
                </CCard>
            </div>
            <CModal :show.sync="cloneModal" centered :title="$t('clonePromotionTitle')"
                color="success" header="false" size="lg" :closeOnBackdrop="false">
                <div class="p-2">

                    <!-- STEP 1: เลือกสาขาปลายทาง -->
                    <template v-if="cloneStep === 'select'">
                        <!-- รายละเอียดโปรโมชั่นที่จะโคลน -->
                        <div class="mb-4 px-3 py-3" style="background-color: #fff8e1; border: 1px solid #ffe082; border-radius: 8px;">
                            <div class="d-flex align-items-start">
                                <img v-if="promotion.details && promotion.details.remoteImagePath"
                                    :src="promotion.details.remoteImagePath"
                                    style="width: 50px; height: 50px; border-radius: 8px; object-fit: cover; margin-right: 12px; flex-shrink: 0;"
                                    @error="$event.target.style.display='none'" />
                                <div style="flex: 1; min-width: 0;">
                                    <div style="font-weight: 600; font-size: 1rem;">
                                        {{ promotion.details?.title || '-' }}
                                    </div>
                                    <div v-if="promotion.details?.description" style="font-size: 0.85rem; color: #666; margin-top: 2px;">
                                        {{ promotion.details.description }}
                                    </div>
                                    <div class="d-flex flex-wrap mt-1" style="gap: 8px; font-size: 0.8rem; color: #888;">
                                        <span v-if="promotion.type">
                                            <i class="fi fi-rr-tags mr-1" style="position: relative; top: 1px;"></i> {{ $t(promotion.type) }}
                                        </span>
                                        <span v-if="promotion.startDate && promotion.endDate">
                                            <i class="fi fi-rr-calendar mr-1" style="position: relative; top: 1px;"></i>{{ formatPromotionRange(promotion) }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- สาขาต้นทาง -->
                        <div class="mb-3 px-2 py-3" style="background-color: #f8f9fa; border-radius: 8px;">
                            <div style="color: gray; font-size: 0.85rem; margin-bottom: 4px;">{{ $t('sourceBranch') }}</div>
                            <div style="font-weight: 600; font-size: 1rem;">
                                {{ currentShop.shopName || currentShop.name || '-' }}
                                <span v-if="currentShop.branchName" style="color: #2eb85c; font-size: 0.85rem; font-weight: 400;">
                                    ({{ currentShop.branchName }})
                                </span>
                            </div>
                        </div>

                        <!-- เลือกสาขาปลายทาง -->
                        <div style="color: gray; font-size: 0.85rem; margin-bottom: 6px;">{{ $t('destinationBranch') }}</div>

                        <!-- จำนวนที่เลือก -->
                        <div v-if="availableShops.length > 0" class="d-flex justify-content-between align-items-center mb-2">
                            <small style="color: #666;">
                                {{ $t('cloneSelectedCount').replace('{count}', selectedBranchCount).replace('{max}', Math.min(cloneMaxBranches, availableShops.length)) }}
                            </small>
                            <CButton size="sm" color="light" @click="toggleSelectAllBranches()"
                                style="font-size: 0.8rem; padding: 2px 10px;">
                                {{ selectedBranchIds.length === availableShops.length ? $t('cloneDeselectAll') : $t('cloneSelectAll') }}
                            </CButton>
                        </div>

                        <div v-if="availableShops.length === 0" class="text-center text-muted py-4">
                            {{ $t('cloneNoAvailableBranch') }}
                        </div>

                        <div v-else style="max-height: 300px; overflow-y: auto; border: 1px solid #d8dbe0; border-radius: 8px;">
                            <div v-for="shop in availableShops" :key="shop.objectId"
                                class="clone-branch-item d-flex align-items-center px-3 py-2"
                                :style="{
                                    borderBottom: '1px solid #f0f0f0',
                                    cursor: isBranchDisabled(shop.objectId) ? 'not-allowed' : 'pointer',
                                    opacity: isBranchDisabled(shop.objectId) ? 0.5 : 1,
                                }"
                                @click="!isBranchDisabled(shop.objectId) && toggleBranchSelection(shop.objectId)">
                                <input type="checkbox"
                                    class="clone-checkbox mr-3"
                                    :checked="isBranchSelected(shop.objectId)"
                                    :disabled="isBranchDisabled(shop.objectId)"
                                    @click.stop="!isBranchDisabled(shop.objectId) && toggleBranchSelection(shop.objectId)"
                                />
                                <div>
                                    <div style="font-size: 0.95rem;">{{ shop.shopName || shop.name }}</div>
                                    <div v-if="shop.branchName" style="font-size: 0.8rem; color: #2eb85c;">{{ shop.branchName }}</div>
                                </div>
                            </div>
                        </div>

                        <div v-if="cloneErrorMessage" class="text-danger text-center mt-3">
                            {{ cloneErrorMessage }}
                        </div>
                    </template>

                    <!-- STEP 2: ตรวจสอบรายละเอียดก่อนยืนยัน -->
                    <template v-else-if="cloneStep === 'review'">
                        <div class="d-flex align-items-center mb-4">
                            <CButton size="sm" color="light" @click="goBackToSelect()"
                                style="border-radius: 8px; padding: 4px 12px; flex-shrink: 0;">
                                <i class="fi fi-rr-arrow-left mr-1" style="position: relative; top: 1px;"></i>
                                {{ $t('cloneGoBack') }}
                            </CButton>
                            <h5 class="text-center mb-0" style="flex: 1;">{{ $t('cloneReviewTitle') }}</h5>
                        </div>

                        <!-- รายละเอียดโปรโมชั่นต้นทาง (แสดง 1 ครั้งนอกกรอบสาขา) -->
                        <div class="mb-4 px-3 py-3"
                            style="background: linear-gradient(135deg, #f0fdf4 0%, #f8fffe 100%); border-radius: 10px; border: 1px solid #c8e6c9;">
                            <div class="d-flex align-items-start">
                                <img v-if="promotion.details?.remoteImagePath"
                                    :src="promotion.details.remoteImagePath"
                                    style="width: 52px; height: 52px; border-radius: 8px; object-fit: cover; margin-right: 12px; flex-shrink: 0;"
                                    @error="$event.target.style.display='none'" />
                                <div style="flex: 1; min-width: 0;">
                                    <div style="font-weight: 600; font-size: 1.02rem;">
                                        {{ promotion.details?.title || '-' }}
                                    </div>
                                    <div v-if="promotion.details?.description"
                                        style="font-size: 0.82rem; color: #666; margin-top: 2px;">
                                        {{ promotion.details.description }}
                                    </div>
                                </div>
                            </div>
                            <div class="mt-3" style="display: grid; grid-template-columns: 1fr 1fr; gap: 6px 12px; font-size: 0.84rem;">
                                <div>
                                    <span style="color: gray;">{{ $t('clonePromotionType') }}</span>
                                    <div style="font-weight: 500;">{{ formatPromotionType(promotion.type) }}</div>
                                </div>
                                <div>
                                    <span style="color: gray;">{{ $t('clonePromotionDateRange') }}</span>
                                    <div style="font-weight: 500;">{{ formatPromotionRange(promotion) }}</div>
                                </div>
                            </div>
                            <!-- สาขาต้นทาง -->
                            <div class="mt-3 pt-2 d-flex align-items-center" style="border-top: 1px solid #c8e6c9;">
                                <i class="fi fi-rr-marker mr-2" style="color: #2eb85c; font-size: 0.9rem;"></i>
                                <div style="font-size: 0.84rem;">
                                    <span style="color: gray;">{{ $t('sourceBranch') }}</span>
                                    <span style="font-weight: 600; margin-left: 6px;">{{ currentShop.shopName || currentShop.name || '-' }}</span>
                                    <span v-if="currentShop.branchName" style="color: #2eb85c; font-weight: 500; margin-left: 4px;">({{ currentShop.branchName }})</span>
                                </div>
                            </div>
                        </div>

                        <!-- เลือกทั้งหมด / สรุปจำนวน -->
                        <div class="d-flex justify-content-between align-items-center mb-3 px-1">
                            <div class="d-flex align-items-center" style="cursor: pointer;"
                                @click="toggleConfirmAllBranches()">
                                <input type="checkbox" class="clone-checkbox mr-2"
                                    :checked="confirmBranchIds.length === cloneCheckResults.length && cloneCheckResults.length > 0"
                                    @click.stop="toggleConfirmAllBranches()" />
                                <span style="font-size: 0.9rem; font-weight: 500;">
                                    {{ confirmBranchIds.length === cloneCheckResults.length ? $t('cloneDeselectAll') : $t('cloneSelectAll') }}
                                </span>
                            </div>
                            <small style="color: #666;">
                                {{ $t('cloneConfirmCount').replace('{count}', confirmBranchIds.length).replace('{total}', cloneCheckResults.length) }}
                            </small>
                        </div>

                        <!-- Loop สาขาที่ check แล้ว — แสดงกรอบแยกตามชื่อสาขา -->
                        <div style="max-height: 420px; overflow-y: auto;">
                            <div v-for="(result, rIdx) in cloneCheckResults" :key="'review-' + rIdx"
                                class="mb-2"
                                style="border-radius: 12px; border: 1px solid #d0d5dd; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.06);">

                                <!-- Header สาขา + checkbox -->
                                <div class="d-flex align-items-center px-3 py-2"
                                    style="background: linear-gradient(90deg, #e8f5e9 0%, #f1f8f4 100%); cursor: pointer;"
                                    @click="toggleConfirmBranch(result.destinationShopObjectId)">
                                    <input type="checkbox" class="clone-checkbox mr-3"
                                        :checked="confirmBranchIds.includes(result.destinationShopObjectId)"
                                        @click.stop="toggleConfirmBranch(result.destinationShopObjectId)" />
                                    <div style="flex: 1;">
                                        <div style="font-weight: 600; font-size: 0.95rem;">
                                            {{ result.destinationShopName || getTargetShopNameById(result.destinationShopObjectId) }}
                                        </div>
                                        <div v-if="result.destinationBranchName || getTargetShopBranchById(result.destinationShopObjectId)"
                                            style="font-size: 0.8rem; color: #2eb85c;">
                                            {{ result.destinationBranchName || getTargetShopBranchById(result.destinationShopObjectId) }}
                                        </div>
                                    </div>
                                    <!-- สถานะ -->
                                    <span v-if="(result.missing?.categories?.length || 0) === 0 && (result.missing?.items?.length || 0) === 0"
                                        style="color: #2eb85c; font-size: 0.8rem; white-space: nowrap;">
                                        <i class="fi fi-rr-check mr-1" style="position: relative; top: 1px;"></i>{{ $t('cloneBranchReady') }}
                                    </span>
                                    <span v-else style="color: #e55353; font-size: 0.8rem; white-space: nowrap;">
                                        <i class="fi fi-rr-triangle-warning mr-1" style="position: relative; top: 1px;"></i>{{ $t('cloneBranchHasMissing') }}
                                    </span>
                                </div>

                                <!-- isActive toggle — แถบแยกใต้ header -->
                                <div class="d-flex align-items-center justify-content-between px-3 py-2"
                                    :style="{
                                        backgroundColor: cloneActiveMap[result.destinationShopObjectId] ? '#dcfce7' : '#f3f4f6',
                                        borderBottom: cloneActiveMap[result.destinationShopObjectId] ? '1px solid #86efac' : '1px solid #e5e7eb',
                                        transition: 'background-color 0.2s ease',
                                    }">
                                    <div class="d-flex align-items-center">
                                        <i :class="cloneActiveMap[result.destinationShopObjectId] ? 'fi fi-rr-bolt' : 'fi fi-rr-moon'"
                                            :style="{ color: cloneActiveMap[result.destinationShopObjectId] ? '#2eb85c' : '#bbb', fontSize: '0.85rem', marginRight: '8px' }"></i>
                                        <small :style="{ color: cloneActiveMap[result.destinationShopObjectId] ? '#1b5e20' : '#888', fontWeight: '500' }">
                                            {{ cloneActiveMap[result.destinationShopObjectId] ? $t('cloneActivateOn') : $t('cloneActivateOff') }}
                                        </small>
                                    </div>
                                    <CSwitch color="success" size="sm"
                                        :checked="cloneActiveMap[result.destinationShopObjectId] || false"
                                        @update:checked="toggleCloneActive(result.destinationShopObjectId)" />
                                </div>

                                <!-- Body รายละเอียด -->
                                <div class="px-3 py-3" style="background-color: #fafcfb;">

                                    <!-- Affected: หมวดหมู่/สินค้าที่ตรงกัน -->
                                    <template v-if="(result.affected?.categories?.length || 0) > 0 || (result.affected?.items?.length || 0) > 0">
                                        <div class="mb-2" style="font-weight: 500; font-size: 0.85rem;">
                                            {{ $t('cloneAffectedTitle') }}
                                        </div>
                                        <div class="mb-1" style="max-height: 130px; overflow-y: auto;">
                                        <div v-for="cat in (result.affected?.categories || [])" :key="'af-cat-' + rIdx + '-' + cat.objectId"
                                                class="d-flex align-items-center py-1 px-2 mb-1"
                                                style="border: 1px solid #b7e4c7; border-radius: 8px; background-color: #e8f8ee; font-size: 0.85rem;">
                                                <i :class="cat.indexIcon || 'fi fi-rr-apps'" class="mr-2"></i>
                                                <span>{{ cat.name }}</span>
                                            </div>
                                            <div v-for="item in (result.affected?.items || [])" :key="'af-item-' + rIdx + '-' + item.objectId"
                                                class="d-flex align-items-center py-1 px-2 mb-1"
                                                style="border: 1px solid #b7e4c7; border-radius: 8px; background-color: #e8f8ee; font-size: 0.85rem;">
                                                <img v-if="item.remoteImagePath" :src="item.remoteImagePath"
                                                    style="width: 32px; height: 32px; border-radius: 4px; object-fit: cover; margin-right: 8px; flex-shrink: 0;"
                                                    @error="$event.target.style.display='none'" />
                                                <div style="flex: 1; min-width: 0;">
                                                    <div>{{ item.name }}</div>
                                                    <div v-if="item.pluCode" style="font-size: 0.75rem; color: gray;">{{ $t('cloneProductCode') }} {{ item.pluCode }}</div>
                                                </div>
                                                <div v-if="item.price != null" class="text-nowrap ml-2" style="font-weight: 500; font-size: 0.85rem;">{{ formatCurrency(item.price) }}</div>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Missing: หมวดหมู่/สินค้าที่ไม่พบ -->
                                    <template v-if="(result.missing?.categories?.length || 0) > 0 || (result.missing?.items?.length || 0) > 0">
                                        <div class="mb-2" style="font-weight: 500; font-size: 0.85rem; color: #e55353;">
                                            {{ $t('cloneMissingTitle') }}
                                        </div>
                                        <CAlert color="warning" class="text-center mb-2" style="font-size: 0.82rem; padding: 6px;">
                                            {{ $t('cloneMissingAlert') }}
                                        </CAlert>
                                        <div class="mb-1" style="max-height: 130px; overflow-y: auto;">
                                            <div v-for="cat in (result.missing?.categories || [])" :key="'ms-cat-' + rIdx + '-' + cat.objectId"
                                                class="d-flex align-items-center py-1 px-2 mb-1"
                                                style="border: 1px solid #f5c6cb; border-radius: 8px; background-color: #fef2f2; font-size: 0.85rem;">
                                                <span class="text-danger">{{ cat.name }}</span>
                                            </div>
                                            <div v-for="item in (result.missing?.items || [])" :key="'ms-item-' + rIdx + '-' + item.objectId"
                                                class="d-flex align-items-center py-1 px-2 mb-1"
                                                style="border: 1px solid #f5c6cb; border-radius: 8px; background-color: #fef2f2; font-size: 0.85rem;">
                                                <span class="text-danger">{{ item.name }}</span>
                                                <span v-if="item.pluCode" class="ml-2" style="font-size: 0.75rem; color: #999;">{{ item.pluCode }}</span>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Conflict Promotions -->
                                    <template v-if="(result.conflictPromotions?.length || 0) > 0">
                                        <div class="mb-2" style="font-weight: 500; font-size: 0.85rem; color: #e65100;">
                                            {{ $t('cloneConflictTitle') }}
                                        </div>
                                        <CAlert color="warning" class="text-center mb-2" style="font-size: 0.82rem; padding: 6px;">
                                            {{ $t('cloneConflictAlert').replace('{count}', result.conflictPromotions.length) }}
                                        </CAlert>
                                        <div class="mb-2" style="max-height: 130px; overflow-y: auto;">
                                            <div v-for="promo in result.conflictPromotions" :key="'cf-' + rIdx + '-' + promo.objectId"
                                                class="p-2 mb-1" style="border: 1px solid #ffe0b2; border-radius: 8px; background-color: #fff8e1; font-size: 0.85rem;">
                                                <div class="d-flex justify-content-between align-items-start">
                                                    <b>{{ promo.title }}</b>
                                                    <span class="text-nowrap ml-2" style="color: gray; font-size: 0.75rem;">{{ $t(promo.type) }}</span>
                                                </div>
                                                <div style="color: gray; font-size: 0.8rem;">{{ formatPromotionRange(promo) }}</div>
                                            </div>
                                        </div>
                                    </template>


                                </div>
                            </div>
                        </div>

                        <div v-if="cloneErrorMessage" class="text-danger text-center mt-3">
                            {{ cloneErrorMessage }}
                        </div>
                    </template>

                    <!-- STEP 3: ผลลัพธ์หลังโคลน -->
                    <template v-else-if="cloneStep === 'result'">
                        <div class="text-center mb-4">
                            <i class="fi fi-rr-check-circle" style="font-size: 2.5rem; color: #2eb85c;"></i>
                            <h5 class="mt-2">{{ $t('cloneResultTitle') }}</h5>
                        </div>

                        <div style="max-height: 380px; overflow-y: auto;">
                            <div v-for="(item, idx) in cloneConfirmResults" :key="'result-' + idx"
                                class="d-flex align-items-center px-3 py-3 mb-2"
                                :style="{
                                    borderRadius: '10px',
                                    border: item.success ? '1px solid #d4edda' : '1px solid #f5c6cb',
                                    backgroundColor: item.success ? '#f0fff4' : '#fff5f5',
                                }">
                                <!-- ไอคอนสถานะ -->
                                <div class="mr-3" style="flex-shrink: 0;">
                                    <i v-if="item.success" class="fi fi-rr-check-circle" style="font-size: 1.4rem; color: #2eb85c;"></i>
                                    <i v-else class="fi fi-rr-cross-circle" style="font-size: 1.4rem; color: #e55353;"></i>
                                </div>
                                <!-- ข้อมูลสาขา -->
                                <div style="flex: 1; min-width: 0;">
                                    <div style="font-weight: 600; font-size: 0.95rem;">
                                        {{ item.data?.shop?.branchName || item.data?.details?.title || getTargetShopNameById(item.destinationShopObjectId) }}
                                    </div>
                                    <div style="font-size: 0.82rem; color: #666;">
                                        {{ getTargetShopNameById(item.destinationShopObjectId) }}
                                        <span v-if="item.data?.shop?.branchName" style="color: #2eb85c;">({{ item.data.shop.branchName }})</span>
                                    </div>
                                    <div v-if="!item.success && item.message" style="font-size: 0.8rem; color: #e55353; margin-top: 2px;">
                                        {{ item.message }}
                                    </div>
                                </div>
                                <!-- สถานะ -->
                                <div class="ml-2 text-nowrap">
                                    <span v-if="item.success" class="badge" style="background-color: #d4edda; color: #155724; padding: 4px 10px; border-radius: 12px; font-size: 0.8rem;">
                                        {{ $t('cloneResultSuccess') }}
                                    </span>
                                    <span v-else class="badge" style="background-color: #f8d7da; color: #721c24; padding: 4px 10px; border-radius: 12px; font-size: 0.8rem;">
                                        {{ $t('cloneResultFailed') }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </template>

                </div>

                <template #footer>
                    <div class="w-100">
                        <template v-if="cloneStep === 'select'">
                            <div class="row">
                                <div class="col-6" >
                                <CButton :disabled="cloneLoading" @click="cloneModal = false" block color="light"
                                    style="flex: 1; border-radius: 8px; font-weight: 500; padding: 10px 0;">
                                    <i class="fi fi-rr-cross-small mr-1" style="position: relative; top: 1px;"></i>
                                    {{ $t('cancel') }}
                                </CButton>
                                </div>
                                <div class="col-6">
                                    <CButton :disabled="cloneLoading || selectedBranchIds.length === 0"
                                        @click="checkClonePromotion()" block color="success"
                                        style="flex: 1; border-radius: 8px; font-weight: 500; padding: 10px 0;">
                                        <CSpinner v-if="cloneLoading" color="white" size="sm" />
                                        <template v-else>
                                            <i class="fi fi-rr-search mr-1" style="position: relative; top: 1px;"></i>
                                            {{ $t('cloneCheck') }}
                                        </template>
                                    </CButton>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="cloneStep === 'review'">
                            <!-- Priority Warning -->
                            <div class="mb-3 p-3" style="background: #fff8e1; border-radius: 8px; border: 1px solid #ffe082;">
                                <div class="d-flex align-items-start">
                                    <i class="fi fi-rr-triangle-warning mr-2" style="color: #f9a825; font-size: 1.1rem; "></i>
                                    <small style="color: #6d5b00;">{{ $t('clonePriorityWarning') }}</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6" >
                                    <!--  @click="cancelClonePromotion()" -->
                                    <CButton :disabled="cloneLoading" @click="cloneModal = false" block
                                        color="danger" variant="outline"
                                        style="flex: 1; border-radius: 8px; font-weight: 500; padding: 10px 0;">
                                        <i class="fi fi-rr-cross-small mr-1" style="position: relative; top: 1px;"></i>
                                        {{ $t('cloneCancel') }}
                                    </CButton>

                                </div>
                                <div class="col-6">
                                    <CButton :disabled="cloneLoading || confirmBranchIds.length === 0" @click="confirmClonePromotion()" block color="success"
                                        style="flex: 1; border-radius: 8px; font-weight: 600; padding: 10px 0;">
                                        <CSpinner v-if="cloneLoading" color="white" size="sm" />
                                        <template v-else>
                                            <i class="fi fi-rr-check mr-1" style="position: relative; top: 1px;"></i>
                                            {{ $t('cloneConfirm') }}
                                        </template>
                                    </CButton>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="cloneStep === 'result'">
                            <CButton @click="cloneModal = false" block color="success"
                                style="border-radius: 8px; font-weight: 600; padding: 10px 0;">
                                <i class="fi fi-rr-check mr-1" style="position: relative; top: 1px;"></i>
                                {{ $t('cloneResultClose') }}
                            </CButton>
                        </template>
                    </div>
                </template>
            </CModal>
        </div>
        <div v-else>
            <access-data></access-data>
        </div>
    </div>
</template>


<script>
import { mapGetters } from 'vuex'
import permis from '@/util/permission'
import pos from '@/services/local';
import moment from 'moment'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-datepicker/index.css'
import 'vue2-timepicker/dist/VueTimepicker.css'
import AppPromotionConditionForm from '@/components/AppPromotionConditionForm';
import AppPromotionResultForm from '@/components/AppPromotionResultForm';
import AppPromotionDetailsForm from '@/components/AppPromotionDetailsForm';
import { CSpinner } from '@coreui/vue';
import '@/assets/styles/promotion.css'
import util from '@/util/util'

export default {
    components: {
        VueTimepicker,
        AppPromotionConditionForm,
        AppPromotionResultForm,
        AppPromotionDetailsForm
    },
    data() {
        return {
            promotion: {
                type: '',
                condition: {
                    type: '',
                },
                results: [],
                details: {
                    title: '',
                    description: '',
                    remoteImagePath: ''
                },
                scope: [],
                isSpecificDay: {},
                quotas: {
                    totalCount: -1,
                    totalCount: -1,
                }
            },
            loadingButton: false,
            saveModal: false,
            activationModal: false,
            deleteModal: false,
            scopes: ['DINE_IN', 'PICK_UP', 'DELIVERY'],
            days: {
                Mon: { index: 0, name: "Monday", openTime: "09:00", closeTime: "17:00", isActive: false },
                Tue: { index: 1, name: "Tuesday", openTime: "09:00", closeTime: "17:00", isActive: false },
                Wed: { index: 2, name: "Wednesday", openTime: "09:00", closeTime: "17:00", isActive: false },
                Thu: { index: 3, name: "Thursday", openTime: "09:00", closeTime: "17:00", isActive: false },
                Fri: { index: 4, name: "Friday", openTime: "09:00", closeTime: "17:00", isActive: false },
                Sat: { index: 5, name: "Saturday", openTime: "09:00", closeTime: "17:00", isActive: true },
                Sun: { index: 6, name: "Sunday", openTime: "09:00", closeTime: "17:00", isActive: true }
            },
            refText: '',
            isSpecificDay: false,
            loading: false,
            noConditionRequired: ['NO_CONDITION', 'ITEM_X_FREE_Y', 'CATEGORY_X_FREE_Y'],
            alertModal: false,
            errorMessage: '',
            cloneModal: false,
            cloneLoading: false,
            cloneErrorMessage: '',
            cloneStep: 'select',
            selectedBranchIds: [],
            cloneActiveMap: {},
            cloneShops: [],
            cloneCheckResults: [],
            confirmBranchIds: [],
            cloneConfirmResults: [],
            cloneMaxBranches: 10,
        }
    },
    computed: {
        ...mapGetters(['shops', 'users', 'date', 'permissions']),
        isPermission() {
            // return permis.findPermissionRead('inventory', this.$route.path)
            const shopObjectId = localStorage.getItem('shopObjectId');
            const selectedShop = this.shops.find(shop => shop.objectId === shopObjectId) || null
            return selectedShop?.currentPlan == "multiplePOS" || false
        },
        shopObjectId: {
            get() {
                return localStorage.getItem('shopObjectId')
            },
        },
        uid: {
            get() {
                return localStorage.getItem('uid')
            },
        },
        promotionObjectId() {
            return this.$route.params.objectId;
        },
        hasRef: {
            get() {
                return this.promotion?.hasRef !== 'NO_REF';
            },
            set(value) {
                this.promotion.hasRef = value ? 'HAS_REF' : 'NO_REF';
            }
        },
        availableShops() {
            return this.cloneShops || []
        },
        currentShop() {
            return (this.shops || []).find(shop => shop.objectId === this.shopObjectId) || {}
        },
        isItemDiscount() {
            // ตัวอย่างจริง: "ITEM_PERCENTAGE_DISCOUNT" → ส่วนลดสินค้า
            return (this.promotion.type || '').startsWith('ITEM_')
        },
        isCategoryDiscount() {
            // เดาตาม pattern เดียวกัน เช่น "CATEGORY_PERCENTAGE_DISCOUNT"
            return (this.promotion.type || '').startsWith('CATEGORY_')
        },
        isDiscountCondition() {
            return this.isItemDiscount || this.isCategoryDiscount
        },
        selectedBranchCount() {
            return this.selectedBranchIds.length
        },
    },
    created() {
        this.getPromotion()
    },
    methods: {
        getPromotion() {
            this.loading = true
            const headers = {
                shopObjectId:util.sanitizeShopObjectId( this.shopObjectId),
                uid: this.uid,
            }
            pos
                .get(`/api/v3.0/shop/promotion/${this.promotionObjectId}`,
                    { headers: headers }
                )
                .then((res) => {
                    this.promotion = res.data?.data || {}
                    if (res.data?.data?.isSpecificDay !== 'NO_SPECIFIC_DAY') {
                        this.isSpecificDay = true
                        this.days = res.data?.data?.isSpecificDay
                    } else {
                        this.isSpecificDay = false
                        this.days = {
                            Mon: { index: 0, name: "Monday", openTime: "09:00", closeTime: "17:00", isActive: false },
                            Tue: { index: 1, name: "Tuesday", openTime: "09:00", closeTime: "17:00", isActive: false },
                            Wed: { index: 2, name: "Wednesday", openTime: "09:00", closeTime: "17:00", isActive: false },
                            Thu: { index: 3, name: "Thursday", openTime: "09:00", closeTime: "17:00", isActive: false },
                            Fri: { index: 4, name: "Friday", openTime: "09:00", closeTime: "17:00", isActive: false },
                            Sat: { index: 5, name: "Saturday", openTime: "09:00", closeTime: "17:00", isActive: true },
                            Sun: { index: 6, name: "Sunday", openTime: "09:00", closeTime: "17:00", isActive: true }
                        }
                    }
                    if (res.data?.data?.hasRef !== 'NO_REF') {
                        this.refText = res.data?.data?.hasRef
                    }

                    this.loading = false
                })
                .catch((error) => {
                    this.loading = false
                    this.$router.push('/promotion')
                    console.error("Error getting promotion:", error);
                });
        },
        handleShopObjectIdChange() {
            this.getPromotion()
        },
        prettyJson(jsonData) {
            return JSON.stringify(jsonData, null, 2);
        },
        toggleSaveModal() {
            const updatedDetails = this.$refs.detailsComponent.getDetails();
            this.promotion = {
                ...this.promotion,
                ...updatedDetails
            };

            if (!this.validatePromotionData()) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                this.errorMessage = 'validateInfomation'
                this.alertModal = true
                return;
            } else {
                this.saveModal = true;
            }
        },

        clearImg() {
            this.promotion.details.remoteImagePath = ''
        },
        toggleImageInput() {
            this.$refs.input_img.click()
        },
        validatePromotionData() {
            const isValid = Object.entries(this.promotion).every(([key, value]) => {
                // Skip validation for optional fields
                if (key === 'isSpecificDay' || key === 'hasRef' || key === 'quotas') {
                    return true;
                }

                if (value === null || value === '' || value === undefined) {
                    console.warn(`Field ${key} is invalid: ${value}`);
                    return false;
                }

                // Validate nested objects (e.g., `details` and `condition`)
                if (typeof value === 'object' && !Array.isArray(value)) {
                    return Object.entries(value).every(([subKey, subValue]) => {
                        // Skip validation for `details.remoteImagePath`
                        if (key === 'details' && subKey === 'remoteImagePath') {
                            return true;
                        }
                        if (subValue === null || subValue === '' || subValue === undefined) {
                            console.warn(`Field ${key}.${subKey} is invalid: ${subValue}`);
                            return false;
                        }
                        return true;
                    });
                }

                // For arrays, ensure they are not empty
                if (Array.isArray(value)) {
                    if (value.length === 0) {
                        console.warn(`Field ${key} is invalid: Array length is 0`);
                        return false;
                    }
                    return value.every(item => item !== null && item !== '' && item !== undefined);
                }

                return true;
            });

            // Check startDate and endDate
            const { startDate, endDate } = this.promotion;
            if (startDate && endDate) {
                const start = new Date(startDate);
                const end = new Date(endDate);

                if (start > end) {
                    console.warn("Validation failed: startDate cannot be after endDate.");
                    return false;
                }
            }

            return isValid;
        },

        saveData() {
            this.loading = true
            window.scrollTo({ top: 0 });
            const headers = {
                shopObjectId:util.sanitizeShopObjectId( this.shopObjectId),
                uid: this.uid,
            }
            pos
                .patch(`/api/v3.0/shop/promotion/${this.promotionObjectId}`, this.promotion, { headers: headers })
                .then((res) => {
                    if (res.data.success == true) {
                        this.loading = false
                        this.$router.push('/promotion');
                        this.saveModal = false;
                    } else {
                        this.errorMessage = res.data?.error?.message || ''
                        this.alertModal = true
                        this.saveModal = false;
                        this.loading = false
                        this.getPromotion()
                    }

                })
                .catch((error) => {
                    this.errorMessage = error
                    this.alertModal = true
                    this.saveModal = false;
                    this.loading = false
                });
        },
        toggleActivationModal() {
            const updatedDetails = this.$refs.detailsComponent.getDetails();
            this.promotion = {
                ...this.promotion,
                ...updatedDetails
            };
            if (!this.validatePromotionData()) {
                this.errorMessage = 'validateInfomation'
                this.alertModal = true
                return;
            } else {
                this.activationModal = true
            }
        },
        deletePromotion() {
            this.loading = true
            const headers = {
                shopObjectId:util.sanitizeShopObjectId( this.shopObjectId),
                uid: this.uid,
            }
            pos
                .delete(`/api/v3.0/shop/promotion/${this.promotionObjectId}`, { headers: headers })
                .then((res) => {
                    this.$router.push('/promotion')
                    this.saveModal = false;
                    this.loading = false
                })
                .catch((error) => {
                    console.error("Error saving promotion:", error);
                    this.saveModal = false;
                    this.loading = false
                });
        },
        isGrabPromotion() {
            const scopes = this.promotion.scopes || []
            if (scopes.length > 0) {
                return scopes.includes('GRAB') || false
            } else {
                return false
            }
        },
        disabledForm() {
            const currentDate = new Date();
            const startDate = this.promotion.startDate ? new Date(this.promotion.startDate) : null;
            if (startDate) {
                const oneHourBefore = new Date(startDate.getTime() - 60 * 60 * 1000)
                return currentDate >= oneHourBefore;
            } else {
                return false;
            }
        },
        toggleGrabInfoModal() {
            this.$refs.detailsComponent.toggleGrabInfoModal()
        },
        getErrorMessage() {
            const errorMessages = {
                '404:catagory': '404Category',
                '400:Invalid parameters!': '400InvalidParameters',
                '400:Category level campaign should have one': '400CategoryOne',
                '400: startTime': '400StartTime',
                '404:item not found': '404Item',
                '400: campaign start time too close for now': '400CampaignStartTime',
                '400:Item(s) are on multiple promotions': '400ItemMultiple',
                '400:Promotion overlaps with other promotions ': '400PromotionOverlaps',
                '400:invalid quotas': '400InvalidQuotas',
                'validateInfomation': 'validateInfomation'
            };

            for (const [key, message] of Object.entries(errorMessages)) {
                if (this.errorMessage.startsWith(key)) {
                    return this.$t(`errorMessagesGrab.${message}`)
                }
            }
            return this.$t('errorMessagesGrab.unknownError')
        },
        toggleCloneModal() {
            this.selectedBranchIds = []
            this.cloneErrorMessage = ''
            this.cloneShops = []
            this.cloneStep = 'select'
            this.cloneActiveMap = {}
            this.cloneCheckResults = []
            this.confirmBranchIds = []
            this.cloneConfirmResults = []
            this.fetchCloneShops()
            this.cloneModal = true
        },
        toggleBranchSelection(shopObjectId) {
            const idx = this.selectedBranchIds.indexOf(shopObjectId)
            if (idx > -1) {
                this.selectedBranchIds.splice(idx, 1)
            } else if (this.selectedBranchIds.length < this.cloneMaxBranches) {
                this.selectedBranchIds.push(shopObjectId)
            }
        },
        isBranchSelected(shopObjectId) {
            return this.selectedBranchIds.includes(shopObjectId)
        },
        isBranchDisabled(shopObjectId) {
            return !this.isBranchSelected(shopObjectId) && this.selectedBranchIds.length >= this.cloneMaxBranches
        },
        toggleSelectAllBranches() {
            if (this.selectedBranchIds.length === this.availableShops.length) {
                this.selectedBranchIds = []
            } else {
                this.selectedBranchIds = this.availableShops.slice(0, this.cloneMaxBranches).map(s => s.objectId)
            }
        },
        toggleConfirmBranch(shopObjectId) {
            const idx = this.confirmBranchIds.indexOf(shopObjectId)
            if (idx > -1) {
                this.confirmBranchIds.splice(idx, 1)
            } else {
                this.confirmBranchIds.push(shopObjectId)
            }
        },
        toggleConfirmAllBranches() {
            if (this.confirmBranchIds.length === this.cloneCheckResults.length) {
                this.confirmBranchIds = []
            } else {
                this.confirmBranchIds = this.cloneCheckResults.map(r => r.destinationShopObjectId)
            }
        },
        toggleCloneActive(shopObjectId) {
            this.$set(this.cloneActiveMap, shopObjectId, !this.cloneActiveMap[shopObjectId])
        },
        fetchCloneShops() {
            this.cloneLoading = true
            const headers = {
                shopObjectId: util.sanitizeShopObjectId(this.shopObjectId),
            }
            pos
                .get('/api/v3.0/shop/clone/promotion/shops', {
                    params: {
                        promotionObjectId: this.promotionObjectId,
                    },
                    headers: headers,
                })
                .then((res) => {
                    this.cloneLoading = false
                    if (res && res.data && res.data.error?.code === 0) {
                        this.cloneShops = res.data.data || []
                    } else {
                        this.cloneShops = []
                        this.cloneErrorMessage = res?.data?.error?.message || this.$t('cloneCheckError')
                    }
                })
                .catch((error) => {
                    console.error("Error fetching clone shops:", error)
                    this.cloneShops = []
                    this.cloneLoading = false
                })
        },
        checkClonePromotion() {
            if (this.selectedBranchIds.length === 0) return
            this.cloneLoading = true
            this.cloneErrorMessage = ''

            const headers = {
                shopObjectId: util.sanitizeShopObjectId(this.shopObjectId),
            }

            pos
                .post('/api/v3.0/shop/clone/promotion/check/multiple',
                    {
                        promotionObjectId: this.promotionObjectId,
                        destinationShopObjectIds: this.selectedBranchIds,
                    },
                    { headers: headers }
                )
                .then((res) => {
                    this.cloneLoading = false
                    if (res && res.data && res.data.error?.code === 0) {
                        // map ให้แต่ละ item เอา .data ขึ้นมาเป็น root level
                        const results = (res.data.data || [])
                            .filter(item => item.success && item.data)
                            .map(item => item.data)
                        this.cloneCheckResults = results
                        this.confirmBranchIds = results.map(r => r.destinationShopObjectId)
                        const activeMap = {}
                        results.forEach(r => { activeMap[r.destinationShopObjectId] = false })
                        this.cloneActiveMap = activeMap
                        this.cloneStep = 'review'
                    } else {
                        this.cloneErrorMessage = res?.data?.error?.message || this.$t('cloneCheckError')
                    }
                })
                .catch((error) => {
                    console.error("Error checking clone promotion:", error)
                    this.cloneErrorMessage = this.$t('cloneCheckError')
                    this.cloneLoading = false
                })
        },
        confirmClonePromotion() {
            if (this.confirmBranchIds.length === 0) return
            this.cloneLoading = true
            this.cloneErrorMessage = ''

            const headers = {
                shopObjectId: util.sanitizeShopObjectId(this.shopObjectId),
            }

            const payload = this.confirmBranchIds.map(shopId => ({
                promotionObjectId: this.promotionObjectId,
                destinationShopObjectId: shopId,
                isActive: this.cloneActiveMap[shopId] || false,
            }))

            pos
                .patch('/api/v3.0/shop/clone/promotion/confirm/multiple',
                    payload,
                    { headers: headers }
                )
                .then((res) => {
                    this.cloneLoading = false
                    if (res && res.data && (res.data.error?.code === 0 || res.data.success === true)) {
                        this.cloneConfirmResults = res.data.data || []
                        this.cloneStep = 'result'
                    } else {
                        this.cloneErrorMessage = res?.data?.error?.message || this.$t('cloneConfirmError')
                    }
                })
                .catch((error) => {
                    console.error("Error confirming clone promotion:", error)
                    this.cloneErrorMessage = this.$t('cloneConfirmError')
                    this.cloneLoading = false
                })
        },
        cancelClonePromotion() {
            this.cloneLoading = true
            this.cloneErrorMessage = ''

            const headers = {
                shopObjectId: util.sanitizeShopObjectId(this.shopObjectId),
            }

            pos
                .patch('/api/v3.0/shop/clone/promotion/cancel',
                    {
                        promotionObjectId: this.promotionObjectId,
                        destinationShopObjectIds: this.selectedBranchIds,
                    },
                    { headers: headers }
                )
                .then((res) => {
                    this.cloneLoading = false
                    this.cloneModal = false
                })
                .catch((error) => {
                    console.error("Error cancelling clone promotion:", error)
                    this.cloneErrorMessage = this.$t('cloneCancelError')
                    this.cloneLoading = false
                })
        },
        goBackToSelect() {
            this.cloneLoading = true
            this.cloneErrorMessage = ''

            const headers = {
                shopObjectId: util.sanitizeShopObjectId(this.shopObjectId),
            }

            pos
                .patch('/api/v3.0/shop/clone/promotion/cancel',
                    {
                        promotionObjectId: this.promotionObjectId,
                        destinationShopObjectIds: this.selectedBranchIds,
                    },
                    { headers: headers }
                )
                .then(() => {
                    this.cloneLoading = false
                    this.cloneCheckResults = []
                    this.cloneStep = 'select'
                })
                .catch((error) => {
                    console.error("Error cancelling clone on back:", error)
                    this.cloneLoading = false
                    this.cloneCheckResults = []
                    this.cloneStep = 'select'
                })
        },
        formatPromotionRange(promo) {
            if (!promo.startDate || !promo.endDate) return ''
            return `${moment(promo.startDate).format('DD/MM/YYYY')} - ${moment(promo.endDate).format('DD/MM/YYYY')}`
        },
        formatCurrency(value) {
            if (value === undefined || value === null) return ''
            return Number(value).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + this.$t('unitBaht')
        },
        getTargetShopNameById(shopId) {
            const shop = (this.cloneShops || []).find(s => s.objectId === shopId)
            return shop?.shopName || shop?.name || '-'
        },
        getTargetShopBranchById(shopId) {
            const shop = (this.cloneShops || []).find(s => s.objectId === shopId)
            return shop?.branchName || ''
        },
        formatPromotionType(type) {
            const map = {
                'ITEM_DOLLAR_DISCOUNT': this.$t('promoTypeItemDollar'),
                'ITEM_PERCENTAGE_DISCOUNT': this.$t('promoTypeItemPercent'),
                'ITEM_FIXED_PRICE': this.$t('promoTypeItemFixed'),
                'CATEGORY_DOLLAR_DISCOUNT': this.$t('promoTypeCategoryDollar'),
                'CATEGORY_PERCENTAGE_DISCOUNT': this.$t('promoTypeCategoryPercent'),
                'CATEGORY_FIXED_PRICE': this.$t('promoTypeCategoryFixed'),
                'RECEIPT_DOLLAR_DISCOUNT': this.$t('promoTypeReceiptDollar'),
                'RECEIPT_PERCENTAGE_DISCOUNT': this.$t('promoTypeReceiptPercent'),
                'BUY_X_GET_Y': this.$t('promoTypeBuyXGetY'),
                'FREE_ITEM': this.$t('promoTypeFreeItem'),
                'ITEM_X_FREE_Y': this.$t('promoTypeItemXFreeY'),
                'CATEGORY_X_FREE_Y': this.$t('promoTypeCategoryXFreeY'),
            }
            return map[type] || type || '-'
        },
        formatPromotionValue(promo) {
            if (!promo || !promo.results || promo.results.length === 0) return '-'
            const result = promo.results[0]
            const value = result.value
            if (value == null) return '-'
            const type = promo.type || ''
            if (type.includes('PERCENTAGE')) {
                return value + '%'
            } else if (type.includes('FIXED_PRICE')) {
                return value.toLocaleString('th-TH') + ' ' + this.$t('unitBaht')
            } else if (type.includes('DOLLAR_DISCOUNT')) {
                return '-' + value.toLocaleString('th-TH') + ' ' + this.$t('unitBaht')
            }
            return value.toLocaleString('th-TH')
        },
        formatScopes(scopes) {
            if (!scopes || scopes.length === 0) return '-'
            const map = {
                'DINE_IN': this.$t('scopeDineIn'),
                'TAKE_AWAY': this.$t('scopeTakeAway'),
                'DELIVERY': this.$t('scopeDelivery'),
                'ALL': this.$t('scopeAll'),
            }
            return scopes.map(s => map[s] || s).join(', ')
        },
        formatCondition(condition) {
            if (!condition || !condition.type) return '-'
            const type = condition.type
            const map = {
                'NO_CONDITION': this.$t('condNoCondition'),
                'BUNDLE_ITEM': this.$t('condBundleItem'),
                'BUNDLE_CATEGORY': this.$t('condBundleCategory'),
                'QUANTITY_ITEM_EXCEED': this.$t('condQuantityItemExceed'),
                'QUANTITY_CATEGORY_EXCEED': this.$t('condQuantityCategoryExceed'),
                'QUANTITY_RECEIPT_EXCEED': this.$t('condQuantityReceiptExceed'),
                'PRICE_ITEM_EXCEED': this.$t('condPriceItemExceed'),
                'PRICE_CATEGORY_EXCEED': this.$t('condPriceCategoryExceed'),
                'PRICE_RECEIPT_EXCEED': this.$t('condPriceReceiptExceed'),
                'ITEM_X_FREE_Y': this.$t('condItemXFreeY'),
                'CATEGORY_X_FREE_Y': this.$t('condCategoryXFreeY'),
                'SAME_CATEGORY_BUNDLE': this.$t('condSameCategoryBundle'),
            }
            let label = map[type] || type

            // เพิ่มรายละเอียด bundle
            if ((type === 'BUNDLE_CATEGORY' || type === 'BUNDLE_ITEM') && condition.bundle && condition.bundle.length > 0) {
                const names = condition.bundle.map(b => {
                    const name = b.category?.name || b.product?.name || '-'
                    return name + (b.quantity > 1 ? ' x' + b.quantity : '')
                })
                label += ' (' + names.join(' + ') + ')'
            }

            // เพิ่มรายละเอียด threshold
            if (['QUANTITY_ITEM_EXCEED', 'QUANTITY_CATEGORY_EXCEED', 'QUANTITY_RECEIPT_EXCEED'].includes(type) && condition.threshold) {
                label += ' ≥ ' + condition.threshold + ' ' + this.$t('unitPiece')
            }
            if (['PRICE_ITEM_EXCEED', 'PRICE_CATEGORY_EXCEED', 'PRICE_RECEIPT_EXCEED'].includes(type) && condition.threshold) {
                label += ' ≥ ' + Number(condition.threshold).toLocaleString('th-TH') + ' ' + this.$t('unitBaht')
            }
            if (['ITEM_X_FREE_Y', 'CATEGORY_X_FREE_Y'].includes(type) && condition.inCartQuantity) {
                const freeQty = this.promotion?.results?.[0]?.freeItemQuantity || condition.freeItemQuantity || '?'
                label += ' — ' + this.$t('itemXFreeYDetailEvery') + ' ' + condition.inCartQuantity + ' ' + this.$t('itemXFreeYDetailFree') + ' ' + freeQty + ' ' + this.$t('itemXFreeYDetailPiece')
            }
            if (type === 'SAME_CATEGORY_BUNDLE' && condition.threshold) {
                label += ' ≥ ' + condition.threshold + ' ' + this.$t('unitPiece')
            }

            return label
        },
    },
    watch: {
        activationModal(newValue) {
            if (newValue == false) {
                this.promotion.isActive = !this.promotion.isActive
            }
        },
        shopObjectId(newVal, oldVal) {
            window.location.href = '/promotion'
        },
    },

}
</script>
<style>
.input-icon-right {
    margin-left: -1px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    border-right: 0.25rem;
    border: 1px solid #ced4da;
}
.clone-checkbox {
    appearance: none;
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    min-width: 20px;
    border: 2px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    position: relative;
    margin: 0;
    transition: all 0.15s ease;
}

.clone-checkbox:checked {
    background-color: #2eb85c;
    border-color: #2eb85c;
}

.clone-checkbox:checked::after {
    content: '';
    position: absolute;
    left: 6px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

.clone-branch-item:hover {
    background-color: #f8f9fa;
}

@keyframes promotionSpin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
